import firebase from "firebase";


export function addUserCampaign(userObject, campaignId, callback) {
    firebase.database().ref(`/users/${firebase.auth().currentUser.uid}/displayName`).once('value').then(function(userObject, campaignId, callback, sp){
        let updated = {};
        updated[`campaign/${campaignId}/users/${userObject.uid}/info`] = {
            displayName: userObject.displayName,
            photoURL: userObject.photoURL
        };
        if(sp.val() === null){
            updated[`users/${userObject.uid}/displayName`] = userObject.displayName;
            updated[`users/${userObject.uid}/email`] = userObject.email;
            updated[`users/${userObject.uid}/photoURL`] = userObject.photoURL;
        }
        firebase.database().ref().update(updated).then(function () {
            if (callback) {
                callback();
            }
        });
    }.bind(null, userObject, campaignId, callback)).catch(function(err){
        console.log(err);
    });



}

export function removeUserFromCampaign(uid, campaignId, callback) {
    firebase.database().ref(`campaign/${campaignId}/users/${uid}`).remove().then(function () {
        callback();
    });
}

export function isRegisterCampaign(campaignId, callback) {
    var unsubscribe = firebase.auth().onAuthStateChanged(function (user) {
        unsubscribe();
        if (user === null) {
            return callback(false, null);
        }
        firebase.database().ref(`campaign/${campaignId}/users/${user.uid}`).once('value', function (sp) {
            if (sp.exists()) {
                return callback(true, sp);
            } else {
                return callback(false, null);
            }
        });
    })


}


// WEBPACK FOOTER //
// ./src/lib/user.js